import Model, { attr, hasMany } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class PropertyTagModel extends Model {
  @attr('string') name!: string;

  @hasMany('property', { inverse: 'propertyTags', async: false })
  properties!: ModelRegistry['property'][];

  @cached
  get searchName(): string {
    return this.name;
  }

  @cached
  get propertyIds(): string[] {
    return this.properties.map((property) => property.id);
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'property-tag': PropertyTagModel;
  }
}
